
const tenantSpecificationsBySubDomain = {
	"benenden": () => import("./Benenden.json"),
	"cadogan": () => import("./Cadogan.json"),
	"chelwestprivatecare": () => import("./ChelWestPPU.json"),
	"circle": () => import("./Circle.json"),
	"ccl": () => import("./ClevelandClinicLondon.json"),
	"genesiscare": () => import("./GenesisCare.json"),
	"hcauk": () => import("./HCA.json"),
	"hje": () => import("./HJE.json"),
	"horderhealthcare": () => import("./Horder Healthcare.json"),
	"pbc": () => import("./IpsenPbc.json"),
	"lillyepromsbreastcancer": () => import("./Lilly Breast Cancer.json"),
	"lillyepromsibd": () => import("./Lilly IBD.json"),
	"mhg": () => import("./MHG.json"),
	"nhssussex": () => import("./NHS Sussex.json"),
	"rcht": () => import("./RCHT.json"),
	"royalsurrey": () => import("./Royal Surrey.json"),
	"signatureclinic": () => import("./Signature Clinic.json"),
	"spencerprivatehospitals": () => import("./Spencer.json"),
	"spire": () => import("./Spire.json"),
	"stjosephs": () => import("./St Joseph's.json"),
	"tlc": () => import("./TLC.json"),
}

export default tenantSpecificationsBySubDomain